import React from 'react';
//import $ from 'jquery';
//import api from '../../../services/api';

export default class NotificacaoForm extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            notification: {
                title: '',
                body: ''
            }
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        //var formElem = e.target;

        var form = new FormData(e.target);
        var data = {};
        for(var [key, value] of form.entries()) {
            data[key] = value;
        }

        if(! data.title || ! data.body) {
            alert("Preencha corretamente o formulário");
            return;
        }

        //var self = this;
        this.setState({loader: true});

        /*

        api.post('/admin/notificacao', data)
        .then(resp => {
            self.setState({loader: false});
            if(resp === true) {
                self.props.refresh();
                $('#' + this.props.elementId).modal('hide');
                formElem.reset();
                return;
            }
            alert("Erro no envio, tente novamente");
        })
        .catch(err => {
            self.setState({loader: false});
            alert("Erro no envio, tente novamente");
        });


        */
    }

    render() {
        const props = this.props;
        // eslint-disable-next-line no-unused-vars
        const {notification, loader} = this.state;

        return (
            <div className="NotificacaoForm">
                <div className="modal fade" tabIndex="-1" role="dialog" id={props.elementId}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                           <div className="modal-header">
                               <h2 className="modal-title">Nova Notificação</h2>
                           </div>
                           <form id={props.elementId + 'Elem'} onSubmit={this.handleSubmit}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <label>Título</label>
                                        <input className="form-control" type="text" name="title" />
                                    </div>
                                    <div className="form-group">
                                        <label>Descrição</label>
                                        <textarea className="form-control" type="text" name="body">
                                        </textarea>
                                    </div>
                                </div>
                                <div className="modal-footer" hidden={loader ? 0 : 1}>
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    <span className="ml-2">
                                        Enviando
                                    </span>
                                </div>
                                <div className="modal-footer" hidden={loader ? 1 : 0}>
                                    <button className="btn btn-light border" data-dismiss="modal">
                                        Cancelar
                                    </button>
                                    <button className="btn btn-primary">
                                        Salvar
                                    </button>   
                                </div>
                           </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}